import Keycloak from 'keycloak-js';

let config = {};
try {
  config = await (await fetch("config.json")).json();
} catch {}

export const api_url = config.api_url;
export const web_client_url = config.web_client_url;
export const environment = config.environment; // development(includes keycloak auth)/production-with-auth/production-no-auth

export const kc = new Keycloak({
    url: config.keycloak_url,
    realm: config.keycloak_realm,
    clientId: config.keycloak_client_id,
  });
  